const TimeViewValueType = {
  Percent: "percent",
  Count: "count",
};

export default TimeViewValueType;
